import { Component, Prop, Element, h ,State} from '@stencil/core';
/**
 * @internal
 */
@Component({
  tag: 'nav-item',
  styleUrl: 'nav-item.css',
  shadow: true,
})
export class NavItem {
  @Prop() label!: string;
  @Prop() target!: string;
  @Prop() icon!: string;
  @Prop() isActive: boolean;
  @Prop() isCollapsed: boolean;
  @Prop() subItems?: Array<{ label: string; target: string ,icon:string}>;

  @Element() el: HTMLElement;

  @State() isExpanded: boolean = false;

  componentWillLoad() {
    // Retrieve expanded state from session storage
    const savedState = sessionStorage.getItem(this.target);
    if (savedState !== null) {
      this.isExpanded = savedState === 'true';
    } else if (this.subItems && this.subItems.some(subItem => window.location.href.includes(subItem.target))) {
      this.isExpanded = true;
    }
  }
  toggleExpand = () => {
    this.isExpanded = !this.isExpanded;
    // Save expanded state to session storage
    sessionStorage.setItem(this.target, this.isExpanded.toString());
  };

  render() {
    return (
      <mainmenu>
        <a href={this.target}>
          <div
            class={{
              active: this.isActive,
              collapsed: this.isCollapsed,
            }}
            onClick={this.subItems ? this.toggleExpand : null}>
            <img src={this.icon}></img>
            {this.isCollapsed ? null : <p>{this.label}</p>}
            {this.subItems && !this.isCollapsed && (
              <span style={{ paddingTop: '5px' }}>
              <img
                src={this.isExpanded ? '/arrow-down.png':'/arrow-right.png' }
                alt={this.isExpanded ? 'Collapse' : 'Expand'}
              />
            </span>
            )}
          </div>
        </a>
        {this.subItems && this.isExpanded && (
          <submenu>
            {this.subItems.map(subItem => (
              <a href={subItem.target} class="submenu-item">
              <div class={{
                active: window.location.href.includes(subItem.target),
                collapsed: this.isCollapsed,
              }}><img src={subItem.icon}></img>
                {this.isCollapsed ? null : <p>{subItem.label}</p>}
              </div>
              </a>
            ))}
            </submenu>
        )}
        </mainmenu>
    );
  }
}
